var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, Center, Spinner, Text } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { BaseDialog, BaseDialogState } from '@/app/UIComponents/BaseDialog';
export class LocalWorkingState {
    constructor() {
        this.baseDialog = new BaseDialogState();
        this.msg = "";
        makeObservable(this);
        this.baseDialog.setHeaderLabel("Working");
        this.baseDialog.setHideFooter(true);
    }
    setMessage(msg) {
        this.msg = msg;
    }
    setLabel(label) {
        this.baseDialog.setHeaderLabel(label);
    }
    setOpen(open) {
        this.baseDialog.setOpen(open);
    }
}
__decorate([
    observable,
    __metadata("design:type", BaseDialogState)
], LocalWorkingState.prototype, "baseDialog", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], LocalWorkingState.prototype, "msg", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LocalWorkingState.prototype, "setMessage", null);
let LocalWorkingDialog = class LocalWorkingDialog extends React.Component {
    constructor(prop) {
        super(prop);
    }
    buildWorkingDialog() {
        return React.createElement(Box, { w: '100%', h: '100%' },
            React.createElement(Center, { w: '100%' },
                React.createElement(Spinner, null)),
            React.createElement(Center, { w: '100%' },
                React.createElement(Text, { mt: '15px' }, this.props.state.msg)));
    }
    render() {
        return (React.createElement(BaseDialog, { state: this.props.state.baseDialog, body: this.buildWorkingDialog() }));
    }
};
LocalWorkingDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], LocalWorkingDialog);
export { LocalWorkingDialog };
